module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_yny-74c4501d3630bdaa41d9adb3ac98742b.png";